import { FC } from "react";

interface AvailableDomainsProps {
    domainNames: string;
}

const AvailableDomains: FC<AvailableDomainsProps> = ({ domainNames }) => {
    const domains = domainNames?.split(',') ?? [];

    return (
        <div className="available-domains-label">
            Available Domains:
            <span className="available-domains-list">
                {domains?.map((n: string, idx: number) =>
                    <span className="domain-badge" key={idx}>{n?.trim()}</span>
                )}
            </span>
        </div>
    );
};

export default AvailableDomains;